import {
  getTimezoneType,
  TimezoneType,
  getWarehouseSavingTime,
  getWarehouseTimezone,
} from './timezoneCache'

export const getNowDate = () => {
  // 获取当前日期
  const date = new Date()

  // 获取当前月份
  let nowMonth: any = date.getMonth() + 1

  // 获取当前是几号
  let strDate: any = date.getDate()

  // 添加分隔符“-”
  const seperator = '-'

  // 对月份进行处理，1-9月在前面添加一个“0”
  if (nowMonth >= 1 && nowMonth <= 9) {
    nowMonth = '0' + nowMonth
  }

  // 对月份进行处理，1-9号在前面添加一个“0”
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  // 最后拼接字符串，得到一个格式为(yyyy-MM-dd)的日期
  const nowDate = date.getFullYear() + seperator + nowMonth + seperator + strDate
  return nowDate
}

/**
 * 格式化时间
 * @param time number | string | Date
 * @param format string,
 * @returns
 */
export const formatTime = (time: number | string | Date, format = 'YYYY-MM-DD') => {
  if (typeof format !== 'string') {
    console.error('无效format参数')
    return ''
  }
  time = time || Date.now()
  const date = new Date(time)
  if (date + '' === 'Invalid Date') {
    console.error('无效time参数')
    return 'Invalid Date'
  }
  const formatMap = {
    Y: date.getFullYear(),
    M: date.getMonth() + 1,
    D: date.getDate(),
    h: date.getHours(),
    m: date.getMinutes(),
    s: date.getSeconds(),
  }
  return format.replace(/([YMDhms])+/g, (_, c) => (formatMap[c] + '').padStart(2, '0'))
}

/**
 * 转换北京时间为仓库时间
 * @param time 字符串
 * @param reversing 是否反转
 * @returns
 */
export function convertBeijingTime2WarehouseTime(time: string | null, reversing = false) {
  const timeType = getTimezoneType()
  if (timeType === null || timeType == TimezoneType.BJ) {
    return time
  }

  if (time === null || time?.trim() == '' || time.includes('0000-00-00')) {
    return time
  }

  const warehouseTimezone = getWarehouseTimezone()
  if (warehouseTimezone == null) {
    return time
  }

  const warehouseSavingTime = getWarehouseSavingTime()
  if (warehouseSavingTime == null) {
    return time
  }

  const date = new Date(time)
  if (date + '' === 'Invalid Date') {
    return time
  }

  const nWarehouseTimezone = Number.parseInt(warehouseTimezone)
  const nWarehouseSavingTime = Number.parseInt(warehouseSavingTime)

  const offsetHours = reversing
    ? 8 - nWarehouseTimezone - nWarehouseSavingTime
    : nWarehouseTimezone - 8 + nWarehouseSavingTime

  date.setHours(date.getHours() + offsetHours)

  return formatTime(date, 'YYYY-MM-DD hh:mm:ss')
}

/**
 * 获取当前时间属于哪个时间端[凌晨，早上，上午，中午，下午，傍晚，晚上，深夜]
 */
export function getTimeRangeText() {
  const currentHours = new Date().getHours()
  const timeRanges = ['凌晨', '早上', '上午', '中午', '下午', '傍晚', '晚上', '深夜']
  const perHourOf24InTimeRanges = [
    0, 0, 0, 0, 0, 1, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4, 5, 5, 6, 6, 6, 6, 7, 7,
  ]
  return timeRanges[perHourOf24InTimeRanges[currentHours]]
}
